import Parse from 'parse';

export const uploadLoadersDataToServer = async (data) => {
  return Parse.Cloud.run('uploadLoadersDataToServer', data);
};

export const getLoadersListForStore = async (data) => {
  return Parse.Cloud.run('getLoadersListForStore', data);
};

export const updateLoadersInfo = async (data) => {
  return Parse.Cloud.run('updateLoadersInfo', data);
};

export const createNewLoader = async (data) => {
  return Parse.Cloud.run('createNewLoader', data);
};

export const markLoaderInOrOut = async (data) => {
  return Parse.Cloud.run('markLoaderInOrOut', data);
};

export const getActiveLoaders = async (data) => {
  return Parse.Cloud.run('getActiveLoaders', data);
};

export const getLoaderActivity = async (data) => {
  return Parse.Cloud.run('getLoaderActivity', data);
};
